
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Input,
  Button,
  Select,
  Option,
  Steps,
  Step,
} from 'element-ui';
import { ITrialForm } from '@/types/trial.d';
import api from '@/api/course';
import tEditor from '@/components/Editor/editor.vue';
import FormMixin from './formMixin';
import firstStep from './firstStep.vue';
import secondStep from './secondStep.vue';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    Button,
    Select,
    Option,
    Steps,
    Step,
    firstStep,
    secondStep,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '添加试听课',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: ITrialForm;

  private types: { value: string; label: string; }[] = [];

  private knowledges: { value: string; label: string; }[] = [];

  private toolbarOptions: any = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }],
  ];

  private curModalComp: string = 'firstStep';

  private courseData: any = [];

  private nextLoading: boolean = false;

  private steps: Array<{ title: string, icon: string }> = [
    {
      title: '基本信息',
      icon: '',
    },
    {
      title: '添加内容',
      icon: '',
    },
  ];

  public $refs!: {
    form: Form,
    tEditor: tEditor;
    stepComp: firstStep;
  }

  get stepActive() {
    /* eslint-disable default-case */
    switch (this.curModalComp) {
      case 'firstStep': return 1;
      case 'secondStep': return 2;
    }
    return 1;
  }

  get datas() {
    return this.oldForm;
  }

  /**
   * @author liangyongmou
   * @desc 提交事件
   * @param { any } row 行数据
   */
  submit() {
    // if (this.title === '编辑正式课内容') {
    //   const form = this.$refs.stepComp.handleSubmit();
    //   const data = new FormData();
    //   data.append('id', form.pid);
    //   data.append('courseDescription', form.content);
    //   api.updataFormalCourseContent(data).then((res: any) => {
    //     this.reset(true, true);
    //   });
    // } else {
    const form = this.$refs.stepComp.handleSubmit();
    if (Object.keys(form).length !== 0) {
      this.courseData = form;
      this.courseData.pid = this.oldForm.pid;
      const data = new FormData();
      Object.keys(this.courseData).forEach((index) => {
        if (this.courseData[index] || this.courseData[index] === 0) {
          data.append(index, this.courseData[index]);
        }
      });
      if (this.title === '编辑正式课') {
        api.editCourse(data).then(() => {
          this.reset(true, true);
          this.nextLoading = false;
          /* eslint-disable no-return-assign */
        }).catch(() => (this.nextLoading = false));
      } else if (this.title === '编辑正式课内容') {
        const contentData = new FormData();
        contentData.append('id', form.pid);
        contentData.append('courseDescription', form.content);
        api.updataFormalCourseContent(contentData).then((res: any) => {
          this.reset(true, true);
        });
      } else {
        api.addCourse(data).then(() => {
          this.reset(true, true);
          this.nextLoading = false;
          /* eslint-disable no-return-assign */
        }).catch(() => (this.nextLoading = false));
      }
    }
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.$log({
      title: `${this.log.name}${close ? '关闭' : '重置'}`,
      component: this.log.component,
    });
    if (this.title === '编辑正式课内容') return;
    this.resetForm();
    this.$refs.tEditor.refresh();
  }
}
